import * as React from 'react';
import { SpinLoader } from 'app/components/spin-loader';
import { useActionCreators, useSelectors } from './hooks';
import { useEffect } from 'react';
import { WithRouterProps } from 'app/components/enhancers/with-router';

/**
 * Runs the action creator to create a new entity then redirects to the draft
 *
 */
export const CaseCreator = (api: any = undefined): React.ComponentType<React.PropsWithChildren<WithRouterProps>> => (
  { params, router }: WithRouterProps
) => {
  const {
    createCase
  } = useActionCreators(api);

  const {
    caseTypeId,
    caseContextId,
    parentConnection,
    entityPath
  } = useSelectors(params, router);

  useEffect(() => {
    createCase(caseTypeId, caseContextId, parentConnection, entityPath);
  }, [caseTypeId, caseContextId, parentConnection]);

  return <SpinLoader />;
};
